import { required, optional } from 'AppReact/schema';
import uuidv4 from 'uuid-browser/v4';
export default {
    id: required('string'),
    name: required('string'),
    phoneNumber: required('string'),
    email: required('string'),
    relationship: required('string'),

    hasError: optional('boolean'),
    nameError: optional('string'),
    phoneNumberError: optional('string'),
    emailError: optional('string'),
    relationshipError: optional('string'),
}


export const defaultEmergencyContacts = {
    id: uuidv4(),
    name: '',
    phoneNumber: '',
    email: '',
    relationship: '',

    hasError: false,
    nameError: '',
    phoneNumberError: '',
    emailError: '',
    relationshipError: '',
}
